import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustBar from "@/components/TrustBar";
import Services from "@/components/Services";
import About from "@/components/About";
import WhyChoose from "@/components/WhyChoose";
import InsuranceSpecial from "@/components/InsuranceSpecial";
import Testimonials from "@/components/Testimonials";
import ServiceArea from "@/components/ServiceArea";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="bg-[#F9FAFB]" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <About />
        <WhyChoose />
        <InsuranceSpecial />
        <Testimonials />
        <ServiceArea />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
